
function Main({children}) {

  return (
    <main className="main container">
      {children}  
    </main>
  )
}


export default Main